module.exports = __webpack_public_path__ + "static/important-insurance-v2-64f4648d250e9e3a77927501ef9552e5.png";